import { loadScript } from "../utils/loadScript";

export default {
  install() {
    loadScript(`https://captcha.253.com/TJCaptcha.js`);
    // loadScript(`https://turing.captcha.qcloud.com/TCaptcha.js`);
  },
};
